import React from 'react';
import AppRoutes from './AppRoutes';
import i18n from './i18n';
import * as CONSTANTS from './config/constants.config';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AppLoader from '@Modules/core/components/Loader';

const queryClient = new QueryClient();

export type LanguageContextType = {
  language: string,
  changeLanguage: (lang: string) => void,
};

const { FRENCH, ENGLISH } = CONSTANTS.LANGUAGE;

export const LanguageContext = React.createContext<LanguageContextType>({
  language: FRENCH,
  changeLanguage: () => null,
});

const App: React.FC = () => {
  const defaultLanguage = i18n.language === ENGLISH ? i18n.language : FRENCH;
  const [language, setLanguage] = React.useState(defaultLanguage);

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    setLanguage(lang);
  };

  return (
    <>
      <LanguageContext.Provider value={{ language, changeLanguage }}>
        <QueryClientProvider client={queryClient}>
          <AppRoutes />
        </QueryClientProvider>
      </LanguageContext.Provider>
    </>
  );
};

export default App;
